export { default } from './AuthModal'



// WEBPACK FOOTER //
// ./src/common/AuthModal/index.js